import { string, date, object, array, number } from "yup"
import { ID2 } from "./yup.common"

export default object({
  date: date().required(),
  vehicleId: ID2("Vehicle").required("Please enter a valid vehicle"),
  labourCount: number(),
  aggregatorId: ID2("Aggregator").required("Please select an aggregator!"),
  sourceDepotId: ID2("Source Depot").required("Please select a source depot!"),
  destinationDepotId: ID2("Destination Depot").required(
    "Please select a destination depot!"
  ),

  organisationUserId: string(),
  estimatedStartTime: string().required("Please enter estimated start time"),
  bookings: array(),
})
